import { getProject } from "../api/project";
export default {
  namespaced: true,
  state: {
    loading: true,
    data: null,
  },
  mutations: {
    setData(state, payload) {
      state.data = payload;
    },
    setLoading(state, payload) {
      state.loading = payload;
    },
  },
  actions: {
    async getData(cxt) {
      if (cxt.state.data) {
        return;
      }
      cxt.commit("setLoading", true);
      const res = await getProject();
      cxt.commit("setData", res);
      cxt.commit("setLoading", false);
    },
  },
};
